import { f as o, l as t } from "./components-BX5DIOPj.mjs";
import { A as w, a as _, b as A, C as D, c as N, F as f, d as x, S as G, e as O, O as P, Q as C, h as F, R as W, U as S, i as U, W as Q, j as R, k as b, m as k, n as v } from "./components-BX5DIOPj.mjs";
import "react/jsx-runtime";
import "react";
import "@monksflow/monks-ui";
import "@tanstack/react-query";
import "ai";
import "@inference.engine/agentic-react";
import "zustand/react/shallow";
import { HostRequestError as h } from "./host-errors.js";
const p = o.COPILOT_AGENT_ID, I = o.WIDGET_DESIGN_AGENT_ID, m = t.guardrailNames, T = o.isWidgetToolId, c = o.widgetIdOfTool, g = o.widgetToolId;
export {
  w as AgentBuilder,
  _ as AgenticUiHostProvider,
  A as AskedQuestions,
  p as COPILOT_AGENT_ID,
  D as CompactionMarker,
  N as ContextRing,
  f as FlowPreview,
  h as HostRequestError,
  x as InspectorField,
  G as InspectorSectionLabel,
  O as InspectorSwitchField,
  P as OpenFlowAssistButton,
  C as QuestionAnnouncer,
  F as QuestionPrompt,
  W as RunDebugPanel,
  S as UI_TEXT,
  U as UiTextProvider,
  I as WIDGET_DESIGN_AGENT_ID,
  Q as WidgetTile,
  R as copilotPanel,
  b as flowEditor,
  m as guardrailNames,
  T as isWidgetToolId,
  k as latestContextUse,
  v as useFlowDocument,
  c as widgetIdOfTool,
  g as widgetToolId
};
//# sourceMappingURL=index.js.map
